import moment from 'moment';

export default class PushOrderUtils {
  public static readonly PERIOD_VALIDATION_DAYS = 40;

  public static readonly COLOR_ERROR = 'error';

  public static readonly COLOR_WARNING = 'warning';

  public static readonly COLOR_SUCCESS = 'success';

  public static isCloseToExpire(expirationDate: string): boolean {
    return moment().startOf('day')
      .add(this.PERIOD_VALIDATION_DAYS, 'days')
      .isAfter(moment(expirationDate, 'YYYY-MM-DD'));
  }

  public static isExpired(expirationDate: string): boolean {
    return moment().startOf('day')
      .isAfter(moment(expirationDate, 'YYYY-MM-DD'));
  }

  public static getIcon() {
    return 'mdi-cart-outline';
  }

  public static getColor(expirationDate: string): string {
    if (expirationDate !== '' && this.isExpired(expirationDate)) {
      return this.COLOR_ERROR;
    }

    if (expirationDate === '' || this.isCloseToExpire(expirationDate)) {
      return this.COLOR_WARNING;
    }

    return this.COLOR_SUCCESS;
  }

  public static getLegend(expirationDate: string): string {
    if (this.isExpired(expirationDate)) {
      return 'PO Expirada';
    }

    if (this.isCloseToExpire(expirationDate)) {
      return `PO expira em ${moment(expirationDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}`;
    }

    return 'PO Informada';
  }
}
